import { defineStore } from "pinia";
import { ref } from "vue";
import { api } from "@/loanLinkApi";

export const useDossierDocumentUrlStore = defineStore(
	"dossierDocumentUrlStore",
	() => {
		const tokens = ref<Record<string, string>>({});
		function $reset() {
			tokens.value = {};
		}

		// TODO: add check for token expiry
		async function getFileUrl(documentId: string) {
			const url = tokens.value[documentId];
			if (url) {
				return url;
			}

			const { data } = await api.document.getDocumentToken(documentId);
			tokens.value[documentId] = data.url;
			return data.url;
		}

		return { getFileUrl, $reset };
	},
);
